import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'concat',
    standalone: true
})
export class ConcatPipe implements PipeTransform {
    constructor() {}

    transform(value: string, delimeter?: string, ...args: string[]): string {
        const str = args?.join(delimeter);
        return str ? value?.concat(delimeter, str) : value;
    }
}
